import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import {ViewService} from "../../../services/common/view.service";
import { PopoverSelectPoiComponent } from '../popover-select-poi/popover-select-poi.component';


// type Layout =
//   "chip" |
//   "item";


@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectComponent implements OnInit {


  // component args

  @Input() placeholder = "SELECT.seleziona";

  @Output() select = new EventEmitter<any>();

  @Input() val;
  @Input() valObj: string;



  // listener

  listener = {
    view: null,
  };



  constructor(
    private cd: ChangeDetectorRef,
    // private navCtrl: NavController,
    // navParams can only be used in modals and popovers!
    // private navParams: NavParams,
    // private tdweb: TdwebService,
    // private dataService: DataService,
    private popoverCtrl: PopoverController,
    // private alertCtrl: AlertController,
    // private modalCtrl: ModalController,
    // private api: ApiService,
    private view: ViewService,
    // private data: DataService,
  ) {}


  ngOnInit() {
    // console.log("ngOnInit()");

    //  -------------------------
    //  listeners:

    this.listenerView();

    //  -------------------------

    // if (!this.status) {
    //   this.status = "off";
    // }
  }

  ngOnDestroy() {
    // console.log("ngOnDestroy()");

    //  -------------------------
    // disengage listeners:

    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }

    //  -------------------------
  }





  /*myFunc() {
    console.log("myfunc", typeof this.val == 'number')
    return typeof this.val == 'number';
  }*/





  switchSelectWindow(event) {
    switch (this.valObj) {
      case "poi":
        this.popoverSelectPoi(event);
        break;

      default:
        break;
    }
  }



  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }


  // popover

  async popoverSelectPoi(event) {
    const popover = await this.popoverCtrl.create({
      component: PopoverSelectPoiComponent,
      componentProps: {
        // componentProp: ,
      },
      cssClass: "popover_list",
      event: event,
    });

    popover.onDidDismiss().then((data: any) => {
      if(data && data.data && data.data.poi){
        this.select.emit(data.data.poi);
      }
    });

    await popover.present();

    // this.select.emit({
    //   name: "selectedPoi's name",
    //   address: "Fake St. 123, New York City (NJ), USA",
    // });
  }






}
